<template>
  <ScreenAdapter>
    <div class="main">
      <div class="header">
        <div class="title">智慧养老可视化系统</div>
      </div>
      <div class="content">
        <div class="left-con">
          <!-- 智能监控 -->
          <div class="left-top">
            <div class="item-title">智能监控</div>
            <div class="devices-con">
              <Devices :deviceData="deviceData"></Devices>
            </div>
          </div>
          <!-- 健康检测 -->
          <div class="left-center">
            <div class="item-title">健康检测</div>
            <el-table
              :data="healthData"
              height="245"
              style="width: 100%; overflow: auto"
              :highlight-current-row="false"
              :row-class-name="tableRowClassName"
              header-row-class-name="header-class"
            >
              <el-table-column prop="time" label="时间" width="100">
                <template slot-scope="scope">
                  <span>{{
                    `${
                      scope.row.finishTime
                        ? scope.row.finishTime.substring(5, 16)
                        : "-"
                    }`
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="姓名" width="200px">
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.elderName }}（{{ scope.row.roomNo }}-{{
                      scope.row.bedNo
                    }}）</span
                  >
                </template>
              </el-table-column>
              <el-table-column prop="detail" label="事项说明">
                <template slot-scope="scope">
                  <span style="color: #50b88d">{{
                    scope.row.resultDesc ? scope.row.resultDesc : "无"
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 表格 -->
          <div class="left-bottom">
            <div class="item-title">机构区域当前活动人数探测</div>
            <div class="data-con">
              <div class="data-item">
                <div class="bg" style="background: #bdc656">
                  {{ nowHumanNumber }}
                </div>
                <div class="title">样板间</div>
              </div>
              <div class="data-item">
                <div class="bg" style="background: #bd6969">35</div>
                <div class="title">活动室</div>
              </div>
            </div>
            <!-- <div class="table-con">
              <el-table
                :data="tableData"
                height="200"
                style="width: 100%; overflow: auto"
                :highlight-current-row="false"
                :row-class-name="tableRowClassName"
                header-row-class-name="header-class"
              >
                <el-table-column prop="id" label="设备ID"> </el-table-column>
                <el-table-column prop="time" label="时间"> </el-table-column>
                <el-table-column prop="position" label="位置">
                </el-table-column>
                <el-table-column prop="status" label="状况">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.status === '正常'"
                      style="color: #50b88d"
                      >{{ scope.row.status }}</span
                    >
                    <span
                      v-if="scope.row.status === '异常'"
                      style="color: #ff4545"
                      >{{ scope.row.status }}</span
                    >
                    <span
                      v-if="scope.row.status === '未处理'"
                      style="color: #c19260"
                      >{{ scope.row.status }}</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div> -->
          </div>
        </div>
        <div class="center-con">
          <div class="center-top">
            <system-info></system-info>
          </div>
          <div class="center-img">
            <div
              class="map-point"
              v-for="item in mapPoint"
              :key="item.building"
              :style="{ left: item.x, top: item.y }"
            >
              <div class="building-no">{{ item.building }}</div>
              <div class="point-icon"></div>
            </div>
          </div>
          <div class="center-bottom">
            <navBar></navBar>
          </div>
        </div>
        <div class="right-con">
          <!-- 安防巡检 -->
          <div class="right-top">
            <div class="space-title">
              <div class="space-left">报警监控</div>
              <div class="space-right">{{ today }}</div>
            </div>
            <div class="alarm-title">
              <div class="title">阶段报警次数：{{ alarmTotal.total }}次</div>
              <div class="select-con">
                <div
                  class="select-item"
                  :class="
                    query.callInfoDateType === item.value ? 'select-active' : ''
                  "
                  v-for="item in select_arr"
                  :key="item.title"
                  @click="handelSelectTime(item)"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="alarm-chart-con">
              <div id="alarm-chart"></div>
            </div>
            <div class="table-con">
              <el-table
                :data="alarmData"
                height="175"
                style="width: 100%; overflow: auto"
                :highlight-current-row="false"
                :row-class-name="tableRowClassName"
                header-row-class-name="header-class"
              >
                <el-table-column prop="time" label="时间">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.lastCallTime
                        ? scope.row.lastCallTime.substring(5, 16)
                        : "-"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="callTypeName" label="报警类型">
                </el-table-column>
                <el-table-column prop="location" label="位置">
                  <template slot-scope="scope">
                    <span
                      >{{ scope.row.buildingNo }}{{ scope.row.roomName
                      }}{{ scope.row.bedName }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="状态">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.status === 2"
                      style="color: #50b88d"
                      >{{ scope.row.statusName }}</span
                    >
                    <span
                      v-if="scope.row.status === 1"
                      style="color: #c19260"
                      >{{ scope.row.statusName }}</span
                    >
                    <span v-if="scope.row.status === 0" style="color: red">{{
                      scope.row.statusName
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 表格 -->
          <div class="right-center">
            <div class="space-title" style="padding: 10px 12px">
              <div class="space-left">巡防监控</div>
              <div class="space-right">{{ today }}</div>
            </div>
            <div class="cruise-chart-con">
              <div id="cruise-chart"></div>
            </div>
            <!-- <Custom-progress
              :progress_data="progress_data"
              customColors="#5497CE"
              marginBottom="10px"
            ></Custom-progress> -->

            <div class="table-con">
              <el-table
                :data="securityData"
                height="175"
                style="width: 100%; overflow: auto"
                :highlight-current-row="false"
                :row-class-name="tableRowClassName"
                header-row-class-name="header-class"
              >
                <el-table-column prop="pointName" label="巡防点">
                </el-table-column>
                <el-table-column prop="createdDate" label="时间">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.createdDate
                        ? scope.row.createdDate.substring(5, 16)
                        : "-"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="executeByName" label="巡访人">
                </el-table-column>
                <el-table-column prop="resultStatusName" label="情况说明">
                  <template slot-scope="scope">
                    <span
                      v-if="scope.row.resultStatus === 2"
                      style="color: #50b88d"
                      >{{ scope.row.resultStatusName }}</span
                    >
                    <span
                      v-if="scope.row.resultStatus === 3"
                      style="color: #ff4545"
                      >{{ scope.row.resultStatusName }}</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 视频监控 -->
          <div class="right-bottom">
            <div class="radio-title">
              <div class="title">视频监控</div>
              <div
                class="more"
                @click="openMonitorModal(monitorGroups[0].url, 0)"
              >
                更多
              </div>
            </div>
            <div class="block-content">
              <div
                class="radio-item"
                v-for="(item, index) in monitorGroups"
                :key="index"
                @click="openMonitorModal(item.url, index)"
              >
                <div class="radio-location">{{ item.position }}</div>
                <video :id="`monitor-${index}`" muted></video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-dialog
      :show.sync="monitorShow"
      :no-head="true"
      @open="monitorOpen"
      @close="monitorClose"
      :append-to-body="true"
      width="70%"
    >
      <div class="preview-video-con">
        <video id="monitor-modal" controls></video>
      </div>
      <div class="preview-container">
        <div
          class="preview-item"
          v-for="(item, index) in monitorList"
          :key="index"
          @click="changeVideoSrc(item.url, index)"
        >
          <div class="video-name">{{ item.position }}</div>
          <video
            :class="previewIndex === index ? 'active-video' : ''"
            :id="`preview-${index}`"
            muted
          ></video>
        </div>
      </div>
    </m-dialog>
  </ScreenAdapter>
</template>

<script>
import { mapState } from "vuex";
import { bigScreenIntelligentDevice } from "@/api/security";
import { presentTime } from "@/utils/date";
import pollingFunction from "@/utils/tools";
import Hls from "hls.js";
import ScreenAdapter from "@/components/ScreenAdapter"; // 自适应组件
import Devices from "@/components/Devices"; // 设备监控
import systemInfo from "@/components/SystemInfo"; // 气温、天气、时间组件
import navBar from "@/components/Navigation"; // 导航菜单
import CustomProgress from "@/components/Progress"; // 进度条组件
import AlarmChart from "../charts/security/alarm.js";
import Highcharts from "highcharts";

export default {
  components: {
    ScreenAdapter,
    Devices,
    systemInfo,
    navBar,
    CustomProgress,
  },
  computed: {
    ...mapState(["mapPoint"]),
  },
  data() {
    return {
      pollingST: null,
      query: {
        callInfoDate: presentTime(),
        callInfoDateType: "month",
      },
      today: presentTime(),
      monitorShow: false,
      player2: null,
      $videoModal: null,
      deviceData: [
        {
          name: "照护手持机",
          icon: require("../assets/security/zhscj.png"),
          device: 0,
        },
        {
          name: "卧床监测",
          icon: require("../assets/security/wcjc.png"),
          device: 0,
        },
        {
          name: "智慧门岗",
          icon: require("../assets/security/zhmg.png"),
          device: 0,
        },
        {
          name: "助餐设备",
          icon: require("../assets/security/zcsb.png"),
          device: 0,
        },
        {
          name: "视频监控",
          icon: require("../assets/security/spjk.png"),
          device: 0,
        },
        {
          name: "健康检测",
          icon: require("../assets/security/jkjc.png"),
          device: 0,
        },
        {
          name: "生命探测",
          icon: require("../assets/security/smtc.png"),
          device: 0,
        },
        {
          name: "紧急呼叫",
          icon: require("../assets/security/jjhj.png"),
          device: 0,
        },
        {
          name: "跌倒监测",
          icon: require("../assets/security/ddjc.png"),
          device: 0,
        },
        {
          name: "安全巡防",
          icon: require("../assets/security/aqxf.png"),
          device: 0,
        },
      ],
      select_arr: [
        {
          title: "月",
          value: "month",
        },
        {
          title: "周",
          value: "week",
        },
        {
          title: "日",
          value: "day",
        },
      ],
      tableData: [
        {
          id: "s001",
          time: "10-01 09:00",
          position: "A102",
          status: "异常",
        },
        {
          id: "s001",
          time: "10-01 09:00",
          position: "A102",
          status: "正常",
        },
        {
          id: "s001",
          time: "10-01 09:00",
          position: "A102",
          status: "未处理",
        },
        {
          id: "s001",
          time: "10-01 09:00",
          position: "A102",
          status: "正常",
        },
      ],
      progress_data: [
        {
          title: "任务进度",
          percentage: 90,
        },
        {
          title: "任务总数量",
          percentage: 100,
        },
        {
          title: "未完成",
          percentage: 20,
        },
        {
          title: "已完成",
          percentage: 80,
        },
      ],
      securityData: [],
      monitorList: [
        {
          position: "南大门",
          url: "https://open.ys7.com/v3/openlive/J22989709_1_1.m3u8?expire=1679039743&id=426408646297223168&t=9527c7ed1304e0b25b96bdd465fe8f9f92bfeef351c3a49a292eb46871300bb3&ev=100",
        },
        {
          position: "康复医院",
          url: "https://open.ys7.com/v3/openlive/J22989709_2_1.m3u8?expire=1679039770&id=426408760196112384&t=ea822e1674c3be3a5f42f9d92f051922d15d83168d159f7fdd95036ed73da8cd&ev=100",
        },
        {
          position: "西大门",
          url: "https://open.ys7.com/v3/openlive/J22989709_3_1.m3u8?expire=1679039800&id=426408886876164096&t=e585a28c9c13de8a3fd5549be28326054edb7d26f57c02efdfe3fe7c18db12aa&ev=100",
        },
        {
          position: "星月广场",
          url: "https://open.ys7.com/v3/openlive/J22989709_4_1.m3u8?expire=1679039811&id=426408932337545216&t=9a66b207c19f283ebbfb8fda51761b51faab1e3435867e4697ebe328e5fb166e&ev=100",
        },
        {
          position: "棋盘广场",
          url: "https://open.ys7.com/v3/openlive/J22989709_5_1.m3u8?expire=1679039825&id=426408988982689792&t=2e88b1be2d422d8515c3e4009ea471ce40db65a4999735387c9176b7bbf21c6e&ev=100",
        },
        {
          position: "16号楼大厅",
          url: "https://open.ys7.com/v3/openlive/J22989709_6_1.m3u8?expire=1679039835&id=426409033480830976&t=92a14f7ebc2637bb4d0809288c21dd9c5c1a84a7e7c609451a29d7259ff25b01&ev=100",
        },
        {
          position: "亲水露台",
          url: "https://open.ys7.com/v3/openlive/J22989709_7_1.m3u8?expire=1679039849&id=426409090272866304&t=44cdabf23f7a0a10a0868530849ca288067746e33fd5b83ba2af77523fecc3e1&ev=100",
        },
        {
          position: "云湖跑道",
          url: "https://open.ys7.com/v3/openlive/J22989709_8_1.m3u8?expire=1679039860&id=426409136592146432&t=ec35a8c901f51a7807d8b6440a3c1a50e3c17d09a1ac68d2eacf9bf3c251e4cb&ev=100",
        },
      ],
      monitorGroups: [],
      previewIndex: 0,
      healthData: [
        {
          time: "10-23",
          name: "张奶奶（101-1）",
          detail: "体温38°",
        },
      ], //监控检测
      alarmData: [
        {
          time: "10:23",
          type: "呼叫报警",
          location: "101-2",
          status: "已处理",
        },
        {
          time: "10:23",
          type: "呼叫报警",
          location: "101-2",
          status: "已处理",
        },
        {
          time: "10:23",
          type: "呼叫报警",
          location: "101-2",
          status: "已处理",
        },
        {
          time: "10:23",
          type: "呼叫报警",
          location: "101-2",
          status: "已处理",
        },
      ], // 报警监测
      alarmTotal: {},
      cruise_data: [], //巡防监控
      nowHumanNumber: 0, //样板间人数
    };
  },
  async mounted() {
    await this.getData();
    this.drawCharts();
    this.monitorGroups = this.monitorList.slice(0, 4);
    this.$nextTick(() => {
      // console.log(this.monitorGroups)
      this.playMonitorGroup();
    });
    //调用轮询;
    setTimeout(() => {
      // 清除现有定时器
      setTimeout(() => {
        this.pollingST = pollingFunction(this.updateCharts, 3000);
      }, 1000);
    }, 1000);
  },
  beforeDestroy() {
    if (!this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    clearTimeout(this.pollingST);
    // this.player1.destroy()
    this.monitorList.forEach((monitor) => {
      if (monitor.player) {
        monitor.player.destroy();
      }
    });
    if (this.player2) {
      this.player2.destroy();
    }
  },
  destroyed() {
    clearTimeout(this.pollingST);
  },
  methods: {
    // 轮询方法
    async polling(params) {
      this.updateCharts(params).then((res) => {
        this.pollingST = setTimeout(() => {
          clearTimeout(this.pollingST);
          this.polling(params);
        }, 10000);
      });
    },
    async getData() {
      const { data: res } = await bigScreenIntelligentDevice({ ...this.query });
      // 智能监控数据
      let device_data = res.data.znjk;
      device_data.forEach((item) => {
        switch (item.typeName) {
          case "手持照护机":
            this.deviceData[0].device = item.number;
            break;
          case "床位监测":
            this.deviceData[1].device = item.number;
            break;
          case "智慧门岗":
            this.deviceData[2].device = item.number;
            break;
          case "智能助餐设备":
            this.deviceData[3].device = item.number;
            break;
          case "摄像头":
            this.deviceData[4].device = item.number;
            break;
          case "健康检测":
            this.deviceData[5].device = item.number;
            break;
          case "生命探测":
            this.deviceData[6].device = item.number;
            break;
          case "呼叫器":
            this.deviceData[7].device = item.number;
            break;
          case "跌倒报警器":
            this.deviceData[8].device = item.number;
            break;
          case "安全巡防":
            this.deviceData[9].device = item.number;
            break;
        }
      });
      // 健康检测
      this.healthData = res.data.jkjcList;
      // 报警监控
      this.alarmTotal = res.data.bjjk;
      this.alarmData = res.data.bjList;
      // 巡防监控
      const xfjk = res.data.xfjk;
      let xfjk_Data = [];
      Object.keys(xfjk).forEach((item) => {
        let obj = {};
        if (item === "total") {
          obj["typeName"] = "任务总数";
          obj["number"] = xfjk[item];
        } else if (item === "wait") {
          obj["typeName"] = "未完成";
          obj["number"] = xfjk[item];
        } else {
          obj["typeName"] = "已完成";
          obj["number"] = xfjk[item];
        }
        xfjk_Data.push(obj);
      });
      this.cruise_data = xfjk_Data;
      this.securityData = res.data.xfjkList;
      // 人数探测
      this.nowHumanNumber = res.data.nowHumanNumber;
    },
    changeVideoSrc(hlsSrc, index) {
      this.hlsModalSrc = hlsSrc;
      this.previewIndex = index;
      if (this.player2) {
        this.player2.destroy();
        this.player2 = null;
      }
      this.$nextTick(() => {
        this.$videoModal = document.querySelector("#monitor-modal");
        this.player2 = this.loadHls(this.$videoModal, this.hlsModalSrc);
        this.player2.on(Hls.Events.MANIFEST_PARSED, () => {
          this.$videoModal.play();
        });
      });
    },
    openMonitorModal(hlsSrc, index) {
      this.hlsModalSrc = hlsSrc;
      this.previewIndex = index;
      this.monitorShow = true;
    },
    playMonitorGroup() {
      this.monitorList.forEach((monitor, j) => {
        if (monitor.player) {
          this.$el.querySelector(`#monitor-${j}`).play();
        } else {
          const hlsSrc = monitor.url;
          const $video = this.$el.querySelector(`#monitor-${j}`);
          monitor.player = this.loadHls($video, hlsSrc);
          monitor.player.on(Hls.Events.MANIFEST_PARSED, () => {
            $video.pause();
          });
        }
      });
    },
    loadHls($video, hlsSrc) {
      const hlsPlayer = new Hls({
        maxBufferSize: 1000 * 1000,
      });
      hlsPlayer.loadSource(hlsSrc);
      hlsPlayer.attachMedia($video);
      hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
        console.error(data);
      });
      return hlsPlayer;
    },
    monitorOpen() {
      if (this.player2) {
        this.player2.destroy();
        this.player2 = null;
      }
      this.$nextTick(() => {
        this.$videoModal = document.querySelector("#monitor-modal");
        this.player2 = this.loadHls(this.$videoModal, this.hlsModalSrc);
        this.player2.on(Hls.Events.MANIFEST_PARSED, () => {
          this.$videoModal.play();
        });
        //预览
        this.monitorList.forEach((monitor, j) => {
          const hlsSrc = monitor.url;
          const $video = document.querySelector(`#preview-${j}`);
          monitor.player = this.loadHls($video, hlsSrc);
          monitor.player.on(Hls.Events.MANIFEST_PARSED, () => {
            $video.play();
          });
        });
      });
    },
    monitorClose() {
      this.$videoModal.pause();
    },
    async drawCharts() {
      this.alarmChart = Highcharts.chart(
        "alarm-chart",
        AlarmChart(this.alarmTotal.rows)
      );
      this.cruiseChart = Highcharts.chart(
        "cruise-chart",
        AlarmChart(this.cruise_data)
      );
    },
    async updateCharts() {
      await this.getData();
      this.alarmChart.update({
        series: [
          {
            data: this.alarmTotal.rows.map((item) => item.number),
            color: "#7CB5EC",
          },
        ],
      });
      this.cruiseChart.update({
        series: [
          {
            data: this.cruise_data.map((item) => item.number),
            color: "#7CB5EC",
          },
        ],
      });
    },
    handelSelectTime(item) {
      this.$set(this.query, "callInfoDateType", item.value);
      this.getData(this.query);
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "simple-row";
      } else if (rowIndex % 2 === 1) {
        return "blue-row";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: calc(100% - 64px);
  height: 100%;
  margin: 0 auto;
  position: relative;
  // background: url("../assets/home/index.png") no-repeat center;
  background: url("../assets/home/bg.jpg") no-repeat center;
  background-size: contain;
  background-position: center 50px;
  ::v-deep .el-table {
    background: transparent !important;
    border: none !important;
  }
  ::v-deep .el-table th {
    background: transparent !important;
    border: none !important;
  }
  ::v-deep .el-table th,
  ::v-deep .el-table tr,
  ::v-deep .el-table td,
  ::v-deep .el-table__body-wrapper {
    border: none !important;
    background-color: transparent;
  }
  ::v-deep .el-table::before {
    height: 0 !important;
  }
  ::v-deep .el-table .el-table__cell {
    padding: 6px 0 !important;
  }
  ::v-deep .el-table .header-class {
    color: #ffffff;
    background: rgba(88, 200, 154, 0.4) !important;
    height: 30px;
  }
  ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    height: 112px;
    background: url("../assets/home/title_bg.png") no-repeat center;
    margin: 0 auto;
    .title {
      font-size: 44px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .content {
    width: 100%;
    height: auto;
    min-height: 932px;
    display: flex;
  }
  .item-title {
    box-sizing: border-box;
    width: 100%;
    padding: 16px 12px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
  }
  .space-title {
    box-sizing: border-box;
    display: flex;
    align-content: center;
    justify-content: space-between;
    width: 100%;
    padding: 0px 12px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    color: #ffffff;
    line-height: 28px;
    .space-left {
      font-weight: bold;
    }
    .space-right {
      font-size: 14px;
    }
  }
  .left-con {
    width: 400px;
    height: 100%;
    .left-top {
      width: 100%;
      height: 490px;
      background: linear-gradient(
        90deg,
        rgba(54, 196, 255, 0.16) 0%,
        rgba(54, 196, 255, 0) 100%
      );
    }
    .left-center {
      width: 100%;
      // height: 275px;
      background: linear-gradient(
        90deg,
        rgba(54, 196, 255, 0.16) 0%,
        rgba(54, 196, 255, 0) 100%
      );
      margin-top: 10px;
    }
    .left-bottom {
      width: 100%;
      height: 190px;
      background: linear-gradient(
        90deg,
        rgba(54, 196, 255, 0.16) 0%,
        rgba(54, 196, 255, 0) 100%
      );
      margin-top: 10px;
      .data-con {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 20px;
        .data-item {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #ffffff;
          font-size: 24px;
          font-family: Microsoft YaHei;
          .bg {
            width: 134px;
            height: 70px;
            line-height: 70px;
            text-align: center;
          }
          .title {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 28px;
          }
        }
      }
    }
  }
  .center-con {
    position: relative;
    flex: 1;
    // height: 100%;
    // overflow: hidden;
    .center-top {
      width: 100%;
      height: 120px;
      display: flex;
      align-content: center;
      margin-top: 10px;
    }
    .center-img {
      position: relative;
      .map-point {
        position: absolute;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        z-index: 2;
        .building-no {
          width: 81px;
          height: 37px;
          line-height: 37px;
          background: linear-gradient(
            90deg,
            rgba(8, 23, 76, 0.2) 0%,
            #071349 50%,
            rgba(5, 20, 80, 0.2) 100%
          );
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          text-align: center;
        }
        .point-icon {
          width: 46px;
          height: 56px;
          background: url("../assets/home/location.png") no-repeat center;
          background-size: contain;
          margin-top: 5px;
        }
      }
    }
    .center-bottom {
      position: absolute;
      bottom: 0px;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 100%;
      height: 148px;
      background: linear-gradient(
        0deg,
        rgba(54, 196, 255, 0.16) 0%,
        rgba(54, 196, 255, 0.04) 100%
      );
      .bottom-item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        &:hover {
          filter: brightness(1.2);
        }
        .icon {
          width: 103px;
          height: 81px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
        .title {
          margin-top: 20px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 28px;
        }
      }
    }
  }
  .right-con {
    width: 400px;
    height: 100%;
    .right-top {
      width: 100%;
      // height: 330px;
      background: linear-gradient(
        -90deg,
        rgba(54, 196, 255, 0.16) 0%,
        rgba(54, 196, 255, 0) 100%
      );
      // overflow: hidden;
      .alarm-title {
        box-sizing: border-box;
        width: 100%;
        padding: 0px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #ffffff;
        font-size: 14px;
        .title {
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 28px;
        }
      }
      .select-con {
        display: flex;
        align-items: center;
        justify-content: center;
        .select-item {
          width: 30px;
          height: 30px;
          line-height: 30px;
          border: 1px solid #5792c9;
          border-radius: 4px;
          color: #ffffff;
          text-align: center;
          margin: 2px 4px;
          cursor: pointer;
        }
        .select-active {
          background: #5792c9;
        }
      }
      .alarm-chart-con {
        width: 100%;
        height: 120px;
        #alarm-chart {
          width: 100%;
          height: 100%;
        }
      }
    }
    .right-center {
      width: 100%;
      background: linear-gradient(
        -90deg,
        rgba(54, 196, 255, 0.16) 0%,
        rgba(54, 196, 255, 0) 100%
      );
      margin-top: 10px;
      overflow: hidden;
      .cruise-chart-con {
        width: 100%;
        height: 120px;
        #cruise-chart {
          width: 100%;
          height: 100%;
        }
      }
    }
    .right-bottom {
      width: 100%;
      height: 300px;
      background: linear-gradient(
        -90deg,
        rgba(54, 196, 255, 0.16) 0%,
        rgba(54, 196, 255, 0) 100%
      );
      overflow: hidden;
      .radio-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          box-sizing: border-box;
          padding: 16px 12px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 28px;
        }
        .more {
          box-sizing: border-box;
          padding: 16px 12px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #7cb5ec;
          line-height: 28px;
          cursor: pointer;
        }
      }
      .block-content {
        box-sizing: border-box;
        width: 100%;
        padding: 0px 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        .radio-item {
          position: relative;
          width: 185px;
          height: 105px;
          background: #346da4;
          margin: 5px 5px;
          .radio-location {
            position: absolute;
            left: 6px;
            bottom: 7px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
          }
          video {
            width: 100%;
            // height: 100%;
            height: auto;
          }
        }
      }
    }
  }
}
</style>
<style>
.preview-video-con {
  width: 100%;
  margin: 0 auto;
}
#monitor-modal {
  width: 100%;
  height: auto;
}
.m-dialog {
  background: #ffffff !important;
}
.preview-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.preview-item {
  position: relative;
  width: 13%;
  margin: 10px 5px;
}
.preview-container video {
  position: relative;
  z-index: 2;
  width: 100%;
  height: auto;
}
.active-video {
  border: 3px solid #2b79bb;
}
.video-name {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 10px;
  z-index: 3;
}
</style>
